var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tab-page-container" },
    [
      _c("terminal-status-modal"),
      _vm._v(" "),
      _c("div", { staticClass: "tab-payments-header" }, [
        _c(
          "table",
          [
            !_vm.selectedTab && !_vm.isLoading
              ? _c(
                  "b-row",
                  { attrs: { "align-h": "center" } },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "my-1",
                        staticStyle: { "text-align": "left" },
                        attrs: { md: "8" },
                      },
                      [
                        _c("toggle-button", {
                          staticClass: "active-toggle",
                          staticStyle: { "font-size": "12pt" },
                          attrs: {
                            color: "#587294",
                            value: _vm.openTabsOnly,
                            sync: true,
                            labels: {
                              checked: _vm.$t("tab_toggle_open_label"),
                              unchecked: _vm.$t("tab_toggle_open_label"),
                            },
                            width: 125,
                            height: 33,
                          },
                          on: {
                            change: function ($event) {
                              _vm.openTabsOnly = !!$event.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("toggle-button", {
                          staticClass: "active-toggle",
                          staticStyle: { "font-size": "12pt" },
                          attrs: {
                            color: "#587294",
                            value: _vm.activeTabsOnly,
                            sync: true,
                            labels: {
                              checked: _vm.$t("tab_toggle_current_label"),
                              unchecked: _vm.$t("tab_toggle_current_label"),
                            },
                            width: 125,
                            height: 33,
                          },
                          on: {
                            change: function ($event) {
                              _vm.activeTabsOnly = !!$event.value
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "my-1", attrs: { md: "4" } },
                      [
                        _c(
                          "b-input-group",
                          [
                            _c("b-form-input", {
                              attrs: {
                                disabled: !!_vm.selectedTab,
                                placeholder: _vm.$t("search"),
                              },
                              model: {
                                value: _vm.filterString,
                                callback: function ($$v) {
                                  _vm.filterString = $$v
                                },
                                expression: "filterString",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-table" },
        [
          _c("b-table", {
            attrs: {
              "sort-by": "createdAt",
              striped: "",
              hover: "",
              "sort-desc": true,
              filter: _vm.filter,
              "filter-function": _vm.tableFilter,
              fields: _vm.tabListFields,
              items: _vm.tabsList,
            },
            on: { "row-clicked": _vm.loadTab },
            scopedSlots: _vm._u([
              {
                key: "cell(guest_id)",
                fn: function (data) {
                  return [
                    _c("span", { staticClass: "tab-guest-name" }, [
                      _vm._v(
                        "\n          " + _vm._s(data.value) + "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedTab
        ? _c(
            "b-modal",
            {
              attrs: {
                visible: !!_vm.selectedTab,
                "dialog-class": "invoice-display-box",
                centered: "",
                "hide-header": "",
                "hide-footer": "",
                "hide-header-close": "",
              },
              on: { hidden: _vm.clearTabs },
            },
            [
              _c(
                "div",
                {
                  attrs: { slot: "default" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                  slot: "default",
                },
                [
                  _c("i", {
                    staticClass: "back-button fi fi-x",
                    on: { click: _vm.clearTabs },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "guest-card" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.selectedGuest) + "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("guest-tab", {
                    class: { "locked-tab": !_vm.isOpen },
                    attrs: {
                      tab: _vm.selectedTab,
                      removeCharge: _vm.removeItemFromTab,
                    },
                  }),
                  _vm._v(" "),
                  _vm.isOpen
                    ? _c("div", { staticClass: "tab-actions" }, [
                        _c(
                          "div",
                          { staticClass: "button-group" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.collectPaymentModal",
                                    modifiers: { collectPaymentModal: true },
                                  },
                                ],
                                staticClass: "invoice-control-button",
                                attrs: {
                                  variant: "outline-success",
                                  size: "xs",
                                },
                                on: { click: _vm.disableCardReader },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("tab_modal_payments_button")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.amountDue === 0
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "invoice-control-button",
                                    attrs: {
                                      size: "xs",
                                      variant: "outline-success",
                                    },
                                    on: { click: _vm.closeOutTab },
                                  },
                                  [
                                    _vm._v(
                                      "\n            Close Tab\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("collect-payment-modal", {
                    ref: "paymentModal",
                    attrs: {
                      payer: _vm.selectedGuest,
                      tab: _vm.selectedTab,
                      loading: _vm.isRequestingPayment,
                    },
                    on: {
                      "submit-payment": _vm.initiateCharge,
                      "submit-adjustment": _vm.updateCurrentTab,
                    },
                  }),
                  _vm._v(" "),
                  _c("tab-item-modal", {
                    ref: "itemModal",
                    attrs: { items: _vm.availableItems },
                    on: { submit: _vm.updateCurrentTab },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }